import { render, staticRenderFns } from "./OfferUdfForm.vue?vue&type=template&id=674db8bf"
import script from "./OfferUdfForm.vue?vue&type=script&lang=js"
export * from "./OfferUdfForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports